export const PEANUT_TARGET = 'quote-modal-peanut-embed';
export const HAS_DISMISSED_STATUS_FOLLOWUP = 'cuehide_has_dismissed_status_followup';
